import { createApi } from '@reduxjs/toolkit/query/react';
import {
  IIstiftaLink,
  IIstiftaLinkCategory,
  CreateIstiftaLinkDto,
  UpdateIstiftaLinkDto,
  ReorderIstiftaLinksDto,
} from '../../common/interfaces/IstiftaLinks.interface';
import { createBaseQuery } from './utils/createBaseQuery';

type ApiResponse<T> = { data: T };

export const istiftaLinksApi = createApi({
  reducerPath: 'IstiftaLinksApi',
  baseQuery: createBaseQuery('/istifta'),
  tagTypes: ['IstiftaLinks', 'IstiftaLinkCategories'],
  endpoints: (builder) => ({
    getIstiftaLinks: builder.query<IIstiftaLink[], void>({
      query: () => '/links',
      transformResponse: (res: ApiResponse<IIstiftaLink[]>) => res.data,
      providesTags: [{ type: 'IstiftaLinks', id: 'LIST' }],
    }),
    getIstiftaLinkCategories: builder.query<IIstiftaLinkCategory[], void>({
      query: () => '/link-categories',
      transformResponse: (res: ApiResponse<IIstiftaLinkCategory[]>) => res.data,
      providesTags: ['IstiftaLinkCategories'],
    }),
    createIstiftaLink: builder.mutation<IIstiftaLink, CreateIstiftaLinkDto>({
      query: (body) => ({ url: '/links', method: 'POST', body }),
      transformResponse: (res: ApiResponse<IIstiftaLink>) => res.data,
      invalidatesTags: [{ type: 'IstiftaLinks', id: 'LIST' }],
    }),
    updateIstiftaLink: builder.mutation<
      IIstiftaLink,
      { id: string } & UpdateIstiftaLinkDto
    >({
      query: ({ id, ...body }) => ({
        url: `/links/${id}`,
        method: 'PUT',
        body,
      }),
      transformResponse: (res: ApiResponse<IIstiftaLink>) => res.data,
      invalidatesTags: [{ type: 'IstiftaLinks', id: 'LIST' }],
    }),
    deleteIstiftaLink: builder.mutation<void, string>({
      query: (id) => ({ url: `/links/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'IstiftaLinks', id: 'LIST' }],
    }),
    reorderIstiftaLinks: builder.mutation<
      IIstiftaLink[],
      ReorderIstiftaLinksDto
    >({
      query: (body) => ({ url: '/links/reorder', method: 'PATCH', body }),
      transformResponse: (res: ApiResponse<IIstiftaLink[]>) => res.data,
      invalidatesTags: [{ type: 'IstiftaLinks', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetIstiftaLinksQuery,
  useGetIstiftaLinkCategoriesQuery,
  useCreateIstiftaLinkMutation,
  useUpdateIstiftaLinkMutation,
  useDeleteIstiftaLinkMutation,
  useReorderIstiftaLinksMutation,
} = istiftaLinksApi;
